import { PlanComparisonCMSItem, PlanComparisonCMSType } from '@grammarly/website-components'
import { PlanCta } from '@components/plans/plan-cta'
import { TypeComponentPlansModuleFields, ContentfulPlanComparisonType } from '@lib/types/component-plans-module'
import { renderRichTextMultiLineContent } from '@components/renderer/rich-text'

const PlanTypeMapping: Record<ContentfulPlanComparisonType, PlanComparisonCMSType> = {
  [ContentfulPlanComparisonType.Free]: PlanComparisonCMSType.Free,
  [ContentfulPlanComparisonType.Pro]: PlanComparisonCMSType.Pro,
  [ContentfulPlanComparisonType.Enterprise]: PlanComparisonCMSType.Enterprise,
}

export function getIndividualPlans(fields: TypeComponentPlansModuleFields): PlanComparisonCMSItem[] {
  return fields.plans.map((plan) => {
    return {
      eyebrow: plan.fields.eyebrow,
      type: PlanTypeMapping[plan.fields.planType],
      title: plan.fields.title,
      description: renderRichTextMultiLineContent(plan.fields.description),
      popular: plan.fields.planType === ContentfulPlanComparisonType.Pro,
      features: plan.fields.features,
      monthlyPriceLabel: plan.fields.monthlyPriceLabel,
      monthlyPricePerMonthLabel: plan.fields.monthlyPricePerMonthLabel,
      cta: <PlanCta cta={plan.fields.cta} />,
    }
  })
}
